import React from 'react';

const SvgTransport6 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 16" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M16 10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zM5 10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zM3.27 1.93a.25.25 0 0 1 .24-.18h11a.25.25 0 0 1 .24.18L15.89 6H2.11zM18 7.56c0-.372-.05-.742-.15-1.1l-1.44-5A2 2 0 0 0 14.49 0h-11a2 2 0 0 0-1.9 1.45l-1.44 5c-.1.361-.15.735-.15 1.11V15a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgTransport6 svgRef={ref} {...props} />);
export default ForwardRef;
